import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from './configureStore';
import { fetchGeoLocationThunk } from '../store/geoLocation/thunks';
import usePromiseWithErrorHandling from './hooks/usePromiseWithErrorHandling';
import { getClientYleApiCredentials } from './utils/authKeys';

interface IGeoLocationProps {
  children: React.ReactNode;
}

const GeoLocation = ({ children }: IGeoLocationProps) => {
  const keys = getClientYleApiCredentials();
  const dispatch = useDispatch<Dispatch>();

  const { run: fetchGeoLocation } = usePromiseWithErrorHandling(() =>
    dispatch(fetchGeoLocationThunk(keys))
  );

  useEffect(() => {
    fetchGeoLocation();
  }, [fetchGeoLocation]);
  return <>{children}</>;
};

export default GeoLocation;
